import React from 'react';
import ParagraphDownloadGetStarted from './GetStarted';
import ParagraphDownload from './Detail';

const Video = (props) => {
  const { viewMode } = props;
  if (viewMode === 'getStarted') {
    return <ParagraphDownloadGetStarted {...props} />;
  }

  return <ParagraphDownload {...props} />;
};

export default Video;
